import axios from 'axios'

axios.defaults.retry = 20;
axios.defaults.retryDelay = 2000;
// axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
// axios.defaults.headers['Accept'] = 'application/json, text/plain, */*'
// axios.defaults.headers = { 'Content-Type': 'application/json' }
import { baseUrl } from '../../../config/build-config'
var api = ''
if (process.env.NODE_ENV === 'development') {
    api = '/api'
}
if (process.env.NODE_ENV === 'production') {
    api = baseUrl
}
const service = axios.create({
    baseURL: api,
    // baseURL: 'http://cms-pro-api.cadwonder.net',
    // baseURL: 'http://cms-dev-api.51ake.com/product',
    timeout: 6000
})
export { api }

export default service


// WEBPACK FOOTER //
// ./src/utils/http/service.js